import { FC } from 'react';
import { StarIconProps } from './types';
import StarIconDefaultVariant from './Variants/StarIconDefault';
import StarIconOutlinedVariant from './Variants/StarIconOutlined';

const StarIcon: FC<StarIconProps> = ({ variant = 'default', ...props }) => {
  const variants = {
    default: <StarIconDefaultVariant variant='default' {...props} />,
    outlined: <StarIconOutlinedVariant variant='outlined' {...props} />
  };
  return variants[variant];
};

export default StarIcon;
